import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import IndustrySearch from "../../components/industry-search/component";
import Faq from "../../components/faq/component";
import ErrorHandler from "../../components/error-handler/component";
import {tokenRegister} from "../../services/tokenRegister";
import {industriesRegister} from "../../services/industriesRegister";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {scraperRegister} from "../../services/scraperRegister";
import ModalImageSize from "../../components/modal-imagesize/component";
import ModalCoupon from "../../components/modal-coupon/component";
import ModalCropp from "../../components/modal-cropp/component";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";
import queryString from "query-string";
import BoosterHeader from "../../components/booster-header/component";
import ModalImageError from "../../components/modal-imageerror/component";

class BoosterVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            image: null,
            images: [],
            uploaded_images: [],
            uploaded_videos: [],
            scraped_images: [],
            isLoadingButton: false,
            isLoading: true,
            page: 0,
            uploaded_image: null,
            uploaded_image_url: null,
            admin: false,
            error: false,
            industries: [],
            hideButton: false,
            src: null
        };
        this.functions.removeSizeModal = this.functions.removeSizeModal.bind(this);
    };

    componentDidMount() {
        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    componentWillMount() {
        window.scrollTo(0, 0);

        
        this.update.user();
        this.update.data();
        //this.update.image();
        this.update.video();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/video');
            ReactGA4.send({ hitType: "pageview", page: "/booster/video" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    update = {
        user: () => {
            try {
                let user = userRegister.get();
                if (user) {
                    this.setState({admin: user.reseller || user.inhouse, inhouse: user.inhouse}, () => {
                        if (!this.state.inhouse) {
                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/booster/images?creative=manual");
                        }
                    });
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/booster/images?creative=manual");
                }
            } catch (error) {
                this.setState({
                    error: true
                });
            }
        },
        data: (updated_industry, industry) => {
            try {
                let stored_data = cartRegister.get();
                if (updated_industry) {
                    stored_data.industry = industry;
                }
                if (stored_data.industry) {
                    this.setState({
                        industry: stored_data.industry
                    }, () => {
                        //this.update.images(this.state.industry.id, updated_industry);
                    });
                } else {
                    //this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'));
                }

            } catch (error) {
                this.setState({error: true});
            }
        },
        video: () => {
            try {
                let stored_video = cartRegister.get();
                if (stored_video.admin_video && stored_video.admin_video_thumbnail) {
                    this.state.uploaded_videos.push({
                        url: stored_video.admin_video,
                        thumbnail: stored_video.admin_video_thumbnail,
                        selected: true
                    });
                }
                this.setState({
                    isLoading: false
                })
            } catch (e) {

            }
        },
    };

    functions = {
        scroll: (element) => {
            let offSet = 0, timeout = null;
            element = document.getElementById(element);
            if (element) {
                const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
                window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
            }
        },
        uploadVideo: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    if (e.target.files[0].type === 'video/mp4') {
                        this.functions.addVideo(e.target.files[0]);
                    } else {
                        this.setState({error_modal: true});
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        addVideo: (file) => {
            let id = Math.floor(Math.random() * 999999999999999999999);
            this.state.uploaded_videos.push({
                id: id,
                url: null,
                loading: true,
            });
            this.setState({
                uploaded_videos: this.state.uploaded_videos
            }, () => {
                let files = new FormData();
                files.append('file', file);
                dataRegister.uploadVideo(files).then((response) => {
                    this.state.uploaded_videos.map((item) => {
                        item.selected = false;
                    });
                    this.state.uploaded_videos.map((item) => {
                        if (item.id === id) {
                            item.url = response.url;
                            item.selected = true;
                            item.thumbnail = response.thumbnail;
                            item.loading = false;
                        }
                    });
                    this.setState({
                        uploaded_videos: this.state.uploaded_videos
                    });
                }, (error) => {
                    console.log(error);
                    this.state.uploaded_videos = this.state.uploaded_videos.filter((item) => {
                        if(item.id !== id){
                            return item;
                        }
                    });
                    this.setState({
                        uploaded_videos: this.state.uploaded_videos,
                        loading_video: false,
                        error_modal: true,
                    });
                });
            });
        },
        dataURItoBlob: (dataURI) => {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type: mimeString});
        },
        removeSizeModal: () => {
            this.setState({size_modal: false})
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-video", item);
        },
        uploadedVideo: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div className={cx(Styles.imagesContainerItemPadding)}>
                        {
                            item.loading && !item.error &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div className={Styles.imagesContainerItemOverlayText}>
                                    <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_41")}</div>
                                </div>
                            </div>
                        }
                        {
                            !item.loading && !item.error &&
                            <div onClick={() => {

                                if (item.selected) {
                                    item.selected = false;
                                    cartRegister.setAdminVideo({url: null, thumbnail: null});
                                    this.setState({
                                        uploaded_videos: this.state.uploaded_videos
                                    });
                                } else {
                                    this.state.uploaded_videos.map((item) => {
                                        item.selected = false;
                                    });
                                    item.selected = true;
                                    this.setState({
                                        uploaded_videos: this.state.uploaded_videos
                                    });
                                }

                                /*
                                if(item.selected){
                                    item.selected = false;
                                    cartRegister.setAdminVideo({url: null, thumbnail: null});
                                    this.setState({
                                        uploaded_videos: this.state.uploaded_videos
                                    });
                                }else{
                                    item.selected = true;
                                    this.setState({
                                        uploaded_videos: this.state.uploaded_videos
                                    }, () => {
                                        cartRegister.setAdminVideo(item);
                                        setTimeout(() => {
                                            let view = quotesRegister.getView();
                                            if (view === "custom") {
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes-custom");
                                            } else {
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes");
                                            }
                                        }, 200);
                                    })
                                }
                                 */
                            }} className={cx(Styles.imagesContainerItemInner)}>
                                {
                                    item.thumbnail && false &&
                                    <div style={{backgroundImage: "url(" + item.thumbnail + ")"}}
                                         className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)}/>
                                }
                                {
                                    item.url &&
                                    <video loop={true} muted={true} autoPlay={true} controls={false}
                                           style={{width: '100%', height: '100%'}}>
                                        <source src={item.url} type="video/mp4"/>
                                    </video>
                                }
                                {
                                    item.selected &&
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{borderColor: '#E65032'}:{}} className={Styles.imagesContainerItemActive}/>
                                }
                            </div>
                        }
                    </div>
                </div>
            )
        },
        uploadVideoButton: () => {
            return (
                <div className={
                    cx(Styles.imagesContainerItem,
                        {
                            [Styles.imagesContainerItemCenter]: this.state.uploaded_videos.length < 1,
                        })
                }>
                    <div className={Styles.imagesContainerItemPadding}>
                        <div className={Styles.imagesContainerItemInner}>
                            <div className={Styles.imagesContainerItemInnerIconContainer}>
                                <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={Styles.imagesContainerItemInnerIcon}>+</div>
                            </div>
                        </div>
                        {
                            <input ref="uploadVideoFile" onClick={() => {
                                this.refs.uploadVideoFile.value = null
                            }}
                                   onChange={(e) => this.functions.uploadVideo(e)} type="file"
                                   accept="video/mp4"
                                   className={Styles.imagesContainerItemInnerUpload}/>
                        }
                    </div>
                </div>
            )
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader analyzing={true} props={this.props}/>
                {
                    this.state.size_modal &&
                    <ModalImageSize setLeave={this.functions.removeSizeModal}/>
                }
                {
                    this.state.error_modal &&
                    <ModalImageError setLeave={() => this.setState({
                        error_modal: false
                    })}/>
                }
                {
                    this.state.cropp_modal &&
                    <ModalCropp setLeave={this.functions.setImageSrc}/>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            {
                                !this.state.error &&
                                <div className={Styles.subtitleContainer}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.title}>
                                        {this.renders.text('item_1')}
                                    </div>
                                </div>
                            }
                            {
                                !this.state.modal &&
                                <div className={
                                    cx(Styles.imagesContainer,
                                        {
                                            [Styles.imagesContainerCenter]: this.state.uploaded_videos.length < 1,
                                        })
                                }>
                                    {
                                        this.state.admin && this.state.industry &&
                                        this.renders.uploadVideoButton()
                                    }
                                    {
                                        this.state.admin && this.state.industry && (this.state.loading_video || this.state.uploaded_video) && false &&
                                        this.renders.uploadedVideo()
                                    }
                                    {
                                        this.state.uploaded_videos.map((item) => {
                                            return (
                                                this.renders.uploadedVideo(item)
                                            )
                                        })
                                    }
                                </div>
                            }
                            <div onClick={() => {
                                try {
                                    let selected = false;
                                    this.state.uploaded_videos.map((item) => {
                                        if (item.selected) {
                                            selected = item;
                                        }
                                    });
                                    if (selected) {
                                        cartRegister.setAdminVideo(selected);
                                    }
                                } catch (e) {
                                }
                                setTimeout(() => {
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slideshow");
                                    /*
                                    let view = quotesRegister.getView();
                                    if(view === "custom"){
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
                                    }else{
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
                                    }
                                    */
                                }, 200);
                            }} className={
                                cx(Styles.button,
                                    {
                                        [Styles.buttonActive]: true,
                                    })
                            }>
                                {this.renders.text("item_30")}
                            </div>
                            <div
                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images?creative=manual")}
                                className={Styles.backButton} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}>
                                {this.renders.text("item_29")}
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default BoosterVideo;


// WEBPACK FOOTER //
// ./src/pages/booster-video/component.js